import { Injectable } from '@angular/core';

declare global {
    interface Navigator {
        mssaveBlob?: (blob: any, defaultName?: string) => boolean;
    }
}

@Injectable({
    providedIn: 'root',
})
export class CsvService {
  exportToCsv(filename: string, rows: object[]) {
      if (!rows || !rows.length) {
          return;
      }
      const separator = ',';
      const flattenedRows = this.flattenObjects(rows);
      const keys = Object.keys(flattenedRows[0]);
      const csvContent =
          keys.join(separator) +
          '\n' +
          flattenedRows
              .map(row => {
                  return keys
                      .map(k => {
                          let cell = row[k] === null || row[k] === undefined ? '' : row[k];
                          cell = cell instanceof Date
                              ? cell.toLocaleString()
                              : cell.toString().replace(/"/g, '""');
                          if (cell.search(/("|,|\n)/g) >= 0) {
                              cell = `"${cell}"`;
                          }
                          return cell;
                      })
                      .join(separator);
              })
              .join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      if (navigator.mssaveBlob) { // IE 10+
          navigator.mssaveBlob(blob, filename);
      } else {
          const link = document.createElement('a');
          if (link.download !== undefined) {
              // Browsers that support HTML5 download attribute
              const url = URL.createObjectURL(blob);
              link.setAttribute('href', url);
              link.setAttribute('download', filename);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
  }

  private flattenObjects(rows: object[]): object[] {
      return rows.map(row => this.flattenObject(row));
  }

  private flattenObject(obj: any): object {
      const result = {};

      function recurse(curr: any, prop: string) {
          if (Object(curr) !== curr) {
              result[prop] = curr;
          } else if (Array.isArray(curr)) {
              const l = curr.length; // Declare 'l' before using it in the loop
              for (let i = 0; i < l; i++) {
                  recurse(curr[i], `${prop}[${i}]`);
              }
              if (l === 0) {
                  result[prop] = []; // This line assigns an empty array if the input array is empty.
              }
          } else {
              let isEmpty = true;
              for (const p in curr) {
                  isEmpty = false;
                  recurse(curr[p], prop ? `${prop}.${p}` : p);
              }
              if (isEmpty && prop) {
                  result[prop] = {};
              }
          }
      }

      recurse(obj, '');
      return result;
  }

}

